import React, { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { AuthShell, IDField } from "@/components/AuthShell";
import { IDButton } from "@/marketing/brand";
import { toast } from "sonner";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const { resetPassword } = useAuth();
  const navigate = useNavigate();
  const token = params.get("token");
  const [f, setF] = useState({ password: "", confirm: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (f.password.length < 8) return toast.error("Password must be at least 8 characters.");
    if (f.password !== f.confirm) return toast.error("Passwords do not match.");
    setBusy(true);
    try {
      await resetPassword(token, f.password);
      toast.success("Password updated. You're signed in.");
      navigate("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This reset link is invalid or expired.");
    } finally { setBusy(false); }
  };

  return (
    <AuthShell title="Set a new password" subtitle="Choose a strong password you'll remember."
      footer={<p className="id-sans text-center text-sm text-[var(--id-charcoal)]/60"><Link to="/login" className="text-[var(--id-walnut)] font-medium id-link-underline">Back to sign in</Link></p>}>
      {!token ? (
        <div className="rounded-2xl border border-[var(--id-mist)] bg-white p-6"><p className="id-sans text-[15px] text-[var(--id-charcoal)]/75">This reset link is missing its token. Please request a new one.</p><div className="mt-4"><IDButton to="/forgot-password" variant="ghost">Request a new link</IDButton></div></div>
      ) : (
        <form onSubmit={submit} className="space-y-4" data-testid="reset-form">
          <IDField label="New password" type="password" value={f.password} onChange={(e) => setF({ ...f, password: e.target.value })} placeholder="At least 8 characters" data-testid="reset-password" autoComplete="new-password" />
          <IDField label="Confirm password" type="password" value={f.confirm} onChange={(e) => setF({ ...f, confirm: e.target.value })} placeholder="Re-enter your password" data-testid="reset-confirm" autoComplete="new-password" />
          <IDButton as="button" type="submit" variant="solid" disabled={busy} className="w-full !py-3.5" testid="reset-submit">{busy ? "Updating…" : "Update password"}</IDButton>
        </form>
      )}
    </AuthShell>
  );
}
